import { RecommendationsBatch } from '@conversations/src/features/overview/types/Recommendations';
import { useQuery, UseQueryResult } from 'react-query';
import { wgApi } from '../../../../../app/src/features/api/wgApi';

interface Params {
  partyId?: string;
}

const getRecommendationsByPartyId = async ({
  partyId,
}: Params): Promise<RecommendationsBatch> => {
  const path = `v1/api/parties/${partyId}/insurance-recommendations`;
  const { data, isError } = await wgApi.get<RecommendationsBatch>(path);
  if (isError) throw new Error('Failed to fetch recommendations');
  return data;
};

export const getUseRecommendationsByPartyQKey = (params: Params) => [
  'party',
  'recommendations',
  params,
];

export const useRecommendationsByParty = (
  params: Params,
): UseQueryResult<RecommendationsBatch> => {
  return useQuery<RecommendationsBatch>(
    getUseRecommendationsByPartyQKey(params),
    () => getRecommendationsByPartyId(params),
    {
      refetchOnWindowFocus: false,
      retry: 1,
      enabled: !!params.partyId,
    },
  );
};
